import React, { Component } from 'react'
import briansusandad from '../images/briansusandad.jpg'
import hornandbuffett from '../images/hornandbuffett.jpeg'
import warrenbuffett from '../images/warrenbuffett.png'

class AboutUs extends Component {

  componentDidMount = () => {
    window.analytics.page()
  }

  render(){

    return (
 <div className="pa6-l">
          
    <h1>
        About Us
    </h1>

    <figure>
  <img src={briansusandad} alt="map" height="275"   />
  <figcaption> Polaris Founders Brian Horn and Susan Pedersen, and their Dad, Dwain </figcaption>
   </figure>

    <figure>
  <img src={hornandbuffett} alt="map" height="275"   />
  <figcaption> Warren Buffett and Dwain Horn </figcaption>
   </figure>
    <h2>
        <em>Stay your course. That’s our motto.</em>
    </h2>
    
    <h2>
        It’s not timing in the market; it’s time in the market.
    </h2>

<p>
    That’s pretty much our investment philosophy. We’re Brian Horn and Susan
    Pedersen. We’re twins. Brother and sister. We created the Polaris
    investment app you’re currently considering (or should be). We grew up in
    Omaha, Nebraska. Yes, that Omaha. The one Warren Buffett was born and
    raised in. Same as us. Only he’s a little older. He’s our dad’s age. In
    fact, our father, who passed away unexpectedly last year, used to sit at
    the same poker table as Warren Buffett (and was one of the first investors
in Buffett’s company,    <a href="https://www.berkshirehathawayhs.com/">Berkshire Hathaway</a>. He
    even had that put in his obituary.
</p>
<p>
<img src={warrenbuffett} alt="map" height="50"   /> &nbsp;&nbsp;
What Dad most coyly left out: though he said he played poker with Warren
    Buffett; he never claimed to have ever beaten the man at the game. What he
    did take away from Buffett, still one of the wealthiest men in the world,
    worth $91.1 billion at last count, were some of the things that many people
    in Omaha, and throughout the world, have applied to their lives and which
    we’ve applied to Polaris. “There are only two things an investor needs to
    know; how to value a company and how to think about stock prices.” Buffett
    said that.
</p>
<p>
    But he’s not the only one with sound investment advice. Here are some other
    things we’re not only fond of but believe in. Some are common sense. Some
    are things that others have said—others far wiser than us. Some are quotes
    that inspire us, guide us, reflect what we are trying to do with
    Polaris—what we are hoping Polaris does for you. Simplicity beats
    complexity. Create value responsibly. Voice how you want the world to work.
</p>
<p>
    What do these sayings mean—in terms of investing? It means investing in
    wonderful businesses at attractive prices, and with conviction. Investing
    in businesses that reflect your personal values. It means investors acting
    like owners, who benefit capitalism by collectively pricing stocks
    rationally.
</p>
<p>
    This requires faith in the future, faith that the markets will eventually
    price your selected stocks at your calculated valuation. That calculated
    valuation, that faith, that’s where Polaris comes in. We do that work for
    you. So that all you need do is decide which companies to invest or not
    invest in. It’s that simple.
</p>
<p>
    <a href="https://www.lawschool.cornell.edu/faculty/bio_lynn_stout.cfm">
        Lynn Stout
    </a>
    , author of “The Shareholder Value Myth: How Putting Shareholders First
    Harms Investors, Corporations, and the Public,” calls this the creation of
    enduring prosperity for stakeholders. Which is just a sound way of
    improving the world. It’s a way of investing that contributes to the public
    well-being by promoting value creation, perpetually renewing
    profits—profits that then ensure production, production that then stays
    aligned with consumer wants and needs.
</p>
<p>
    So why are we doing this? Why did we develop Polaris? Believe it or not, it
    wasn’t (just) to make money. It’s because we want people to have a voice in
    how they use their money. To reassure people, especially people wanting to
    invest their money for the first time, or who know little to nothing about
    stocks or the stock market, that they as individuals can have a say in
    their money—and in their future. That your money matters—not just to you,
    but based on how you invest it, to society as well. This is what our father
    passed on to us. And, in a way, it was and still is the culture of Omaha.
    As Susan has said of our hometown (where she still lives), particularly
    when Buffett’s Berkshire Hathaway holds its annual shareholders meeting
    (which brings in nearly 40,000 people—way up from the 500 or so who
    attended when our father used to take her with him to these meetings),
    “Omaha is the Woodstock of capitalism.” Even so, as wealthy as it is in
    Omaha, people do not flout their wealth. There’s no (legal) gambling in
    Omaha; the casinos are across the way. Buffett’s father and grandfather ran
    a grocery store. Which is not that different from running a farm. Which
    means people tend to have worked hard for what they’ve earned, and rarely
    made money overnight.
</p>
<p>
Slow. Steady. Boring. Be slow and steady in your investments—i.e.,    <em>Stay your course</em>. It’s not timing in the market--it’s time in the
    market. Coming from families who had that good ol’ Midwestern work ethic
    (each of our grandfathers were farmers, one of whom also raised sheep, and
    would sometimes spend the night in the barn, shotgun in hand, to protect
them), we were raised, too, by a father, an actuarial planner with    <a href="https://www.mutualofomaha.com/">Mutual of Omaha</a>, who was
    always looking 10 years down the road. That was his job. He taught us not
    only how to live in the moment, but, more important to him, to always be
    asking ourselves: Where do you want to end up?
</p>
<p>
Susan and I first ended up at the    <a href="https://www.unl.edu/">University of Nebraska</a>. In Lincoln. I’d
    gone there on a football scholarship (awarded to me by the big man himself,
    coach Tom Osborne), and Susan started out as a business major but
    eventually got her degree in English. I soon lost interest in football.
    (Susan’s first husband, though, was Jeff Hansen, a Cornhusker safety who
    ended up on the cover of <u>Sports Illustrated</u>.) I ended up with a
degree in computer science, then moved down to Dallas for a job at    <a href="http://www.ti.com/">Texas Instruments</a>, who, back then, was at
    the forefront of semiconductor development.
</p>
<p>
    I was the only undergrad among a bunch of PhD guys. And I remember asking
    one of them one day what he’d written his dissertation on. He said,
    Non-Flat Eigenvalues. So, I asked him: What’s the commercial value of that?
    He was so taken aback just by the question itself. That was a big lesson
    for me. I knew right then I wanted to get away from pure research. So, I
jumped at the opportunity to go to work for    <a href="https://www.microsoft.com/en-us/">Microsoft</a>, who’d just opened
    a facility in Dallas—trying to create products that people would see and
    use.
</p>
<p>
    Susan, meanwhile, went to work for First Data Resources (now &nbsp;
    <a href="https://www.firstdata.com/en_us/home.html">
        First Data Corporation
    </a>
    ), one of the biggest credit-card processing companies in the world. She
started out there in human resources. But soon returned to school, to the    <a href="https://www.unomaha.edu/">University of Nebraska at Omaha</a>, for
    an MBA. She then taught there, the only woman in the computer science
    department, for 15 years. “Our mom had a PhD in early childhood education,
    so it wasn’t like I wasn’t used to the world of academics,” says Susan. “It
    was a natural thing to teach, and it gave me a really good foundation in
    technology. Understanding how computers work—even the physics of them.
    Being able to take them apart and show students how they work. I was able
    to watch technology evolve and see where it was going and see how people
    were challenged by where it was going.” Tired of grading papers, she then
landed a job with the    <a href="https://www.up.com/index.htm">Union Pacific Railroad</a>, where
    she managed a team of software engineers.
</p>
<p>
    Getting back to our father, when we were kids, he explained to us how the
    stock market, and investing, worked. And he let us make mistakes. In the
    mid-70s, Susan bought stock in a shoe she was most familiar with: New
    Balance. Because our dad had told us, as we will tell you: Pick something
    you know, pick something you like. Susan, however, lost almost half the
    money she’d invested. Why? Nike came out with their first line of Swoosh
    shoes right after she bought stock in New Balance—and revolutionized the
    sneaker industry. But, as Susan admits now, she wasn’t patient. She sold
    when her stock went down by $3,000. And she never wanted to invest in
    individual stocks again.
</p>
<p>
    Then, over a 20-year period, I came up with my investment algorithm based
    on extensive research into economic and financial theories. And Susan then
    became a sounding board for my investing approach. And my app. Once I
    showed her what Polaris could do, how easy it made investing, she became
    more interested. Not only as a potential investor, but because the theories
    I’ve developed, what makes Polaris unique among all the different stock
    market investment apps out there, is that it’s transparent. And it provides
    a PLAN.
</p>
<p>
    As Susan has started to proselytize, “The investing world is the most
    opaque industry in the world, where people are throwing money at something
    they don’t understand. And people who are supposed to be giving you advice
    often make it even harder to understand.” Both Susan and Brian firmly
    believe that we need to make our money work for us and not the other way
    around. And, that investing in other people, other companies, isn’t just to
    enrich ourselves—to make us independently wealthy—but to benefit society.
    In short: Pay it forward.
</p>
<p>
    So, when it comes to investing, don’t wait till your 30 or 40. Start
    investing in your 20s. We want people, especially people starting out, to
    have a voice in how they use their money. We want to empower people to
    invest more in what they believe in. So that you as an investor have an
    impact on the bigger picture. Because you can. Nowadays, investors,
    stockholders in particular, lose sight of where their money is going and
    its purpose. Polaris gives you a currency of purpose. It gives you a sense
    of pride in where you’re putting your money. If you put it all your money
    into an &nbsp;
    <a href="https://www.standardandpoors.com/en_US/web/guest/home">
         S&amp;P 500 
    </a>
   &nbsp; index fund, for instance, that doesn’t really say anything about you or
    your values.
</p>
<p>
    As I envision it, I see Polaris as a jazz band, as opposed to an orchestra.
    An orchestra has a prearranged script that’s played the way it’s been laid
    out. Whereas in jazz, or with Polaris, we lay out enough of a game plan,
    but we let you go your own way. We empower you to do your own thing, but in
    a way that, as a group, the group itself pools its talents and accomplishes
    something greater than what could’ve been done as individuals. In turn,
    that helps to create a stronger capitalistic system
</p>
<p>
    The Polaris origin story comes from an interaction with my oldest son from
    about 10 years ago, back when he turned 14. (It’s not unlike what drove &nbsp;
    <a href="https://www8.gsb.columbia.edu/cbs-directory/detail/jmg117">
        Joel Greenblatt
    </a>
    &nbsp; to write his classic, <em>The Little Book that Beats the Market,</em> after
    one of his sons turned 15.) My son had been given some money for Christmas.
    He wanted to invest it but didn’t know how or into what. So, I told him,
    put it into something you like. He did. And after six months he hadn’t done
    very well. So, I asked him, what did you learn? He apparently learned
    plenty. Because when he invested the second time around, he put money into
a company he used often and really liked:    <a href="https://www.netflix.com/">Netflix</a>. And he has done unusually
    well. That has encouraged me to say to people who are in their early 20s,
    you’ll be in such a different place by your 30s if you invest now. But do
    it with conviction. Do it with patience.
</p>
<p>
    Staying your course is a big part of it. So many people are in and out of
    the market so quickly they don’t do well on average. They aren’t even in
    long enough for there to even be an average. That’s not how you’re going to
    do well. My advice, then, is even more simple: If you’re not going to stick
    with it, don’t bother. Because you are going to be tested. Which is where
    Polaris comes in. Polaris allows you to create an investment plan for each
    stock. It’s not just about buying and selling. It helps you clearly
    identify a year or two from now how or where things should be in the stock
    market. And incorporated into Polaris is the fact that there is a range,
    there’s a wobble. There’s variation. (That’s why no one has yet been able
    to predict a winner every time out.) If you’re 15 percent down from where
    you bought in, don’t flip out. If you’re within the plan range, don’t worry
    about it. You’re fine. That is within expectations. As I like to say,
    “sleep well at night knowing you’ve made a thoughtful decision.”
</p>
<p>
    If the stock price is falling, Polaris can show you that it’s not so bad
    that you should get out. That’s what Polaris shows you. That’s the
    transparency Susan sees as so revolutionary. It’s a very clear plan. And
    it’s dynamic. It reacts to the price and will adjust. Like jazz. And it’s
    based on history of stocks and the stock market. It incorporates the wisdom
    of the crowds while still acknowledging the occasional madness of the mob.
    It’ll help you navigate those questions that sometimes come up about
    certain stocks performances: Does the price today reflect the wisdom of the
    crowd? If so, we should pay heed to that. Or does it reflect a kind of
    madness? Polaris helps you put your stock investments into perspective. It
    helps you see the market in a broader context. It’s what I refer, and
    others refer to as<strong> practical valuation investing</strong>. Not to
    get too technical, but there are usually two ways of looking at the stock
    market: academic valuation and practical valuation. Polaris leans more
    toward the practical while still giving credence to the academic. We take
    the middle ground.
</p>
<p>
    “Many times, this industry doesn’t want you to know what’s going on,” says
    Susan. “The key is to have a benchmark to judge yourself against. And the
    transparency. Those are huge. And that’s the beauty of Polaris. That’s what
    Polaris provides people. Which is an almost a revolutionary thing.” In this
    way, Polaris helps people choose good valuable businesses that ought to
    perform but when they don’t—you see it. Right away. It also allows users of
    Polaris to invest in companies that they feel are doing good things. Not in
    bad companies doing bad things. Which goes back to that concept of
    compassionate capitalism.
</p>
<p>
What’s essential, no matter where you are in your investments:    <strong>Stay your course</strong>. It’s not timing in the market; it’s time
    in the market. We give you an investment plan for each and every stock that
    says, Yeah, your stock might drop but don’t sell until it gets to this
    point. What that does is it makes for a more confident investor. A more
    confident you who looks at things long-term. Who invests in well-valued
    companies that are doing good things. (The opposite would be speculative
    day traders (gamblers really)—of whom there are many.) Susan, for example,
    talks about the many benefits, personal and societal, of investing in, say,
    an axle manufacturing company in New Jersey. “That feels good—to have your
    money invested in a company that’s in a town where they have an annual
    parade.” Hokey? Old-fashioned? Maybe. But it’s what we believe in. It’s
    been working for us. And it’s what we believe will work for you as well.
</p>
<p>
We hope you find investing success using Polaris. If you have any questions or comments, please don't hesitate to contact us.
</p>
<p>Sincerely,</p>
<p>Brian Horn and Susan Pedersen, Co-Founders
</p>
    </div>
    )
  }
}

export default AboutUs



// WEBPACK FOOTER //
// ./src/components/AboutUs.js